import { cloneDeepWith } from 'lodash';
import { allElements, createElementIdGenerator, holdsFields, optionsOf } from '../../format/elements';
import type { Element, FormDefinition } from '../../format/form-definition';
import type { IdPrefix } from '../../format/elements';

export type CopyIds = Map<string, string>;

export const drawCopyIds = (form: FormDefinition, element: Element): CopyIds => {
  const draw = createElementIdGenerator(form);
  const ids = new Map<string, string>();
  for (const original of allElements([element])) {
    ids.set(original.id, draw(prefixOf(original)));
    if (original.kind === 'field') for (const option of optionsOf(original)) ids.set(option.id, draw('opt'));
  }
  return ids;
};

const prefixOf = (element: Element): IdPrefix => {
  if (element.kind === 'section') return 'sec';
  if (element.kind === 'staticText') return 'txt';
  return holdsFields(element) ? 'grp' : 'fld';
};

export const copyOf = (element: Element, ids: CopyIds): Element => {
  return cloneDeepWith(element, value => (typeof value === 'string' ? (ids.get(value) ?? value) : undefined));
};
